export class ElectronicInvoicingEntity {
    Id: number;
    Siren: string;
    Name: string;
    ElectronicInvoicingAddress: string;
    QrCodeContent: string;

    constructor(model?: ElectronicInvoicingEntity) {
        if (model) {
            this.Id = model.Id;
            this.Siren = model.Siren;
            this.Name = model.Name;
            this.ElectronicInvoicingAddress =
                model.ElectronicInvoicingAddress;
            this.QrCodeContent = model.QrCodeContent;
        } else {
            // New entity: send Id 0 (not null) so it binds to the non-nullable
            // int on the API side, matching the EmployeeCategory create convention.
            this.Id = 0;
            this.Siren = null;
            this.Name = null;
            this.ElectronicInvoicingAddress = null;
            this.QrCodeContent = null;
        }
    }
}
